<div class="bored-wrap">
    <div class="container">
        <div class="row">
            <div class="col">
                <h1>Joke:</h1>
                <div>{{joke.setup}} <br> {{joke.punchline}}</div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h1>Activity:</h1>
                <div>{{activity.activity}}</div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h1 class="text-center">{{drink.strDrink}}</h1>
                <div class="text-center">
                    <img src="{{drink.strDrinkThumb}}" alt="" height="400px" width="400px">
                </div>
                <div>Ingredients:</div>
                <div class="" *ngFor="let i of numbers">
                    <div *ngIf="drink['strMeasure' + i]">{{i}} - {{drink["strMeasure" + i]}} {{drink["strIngredient" + i]}}</div>
                </div>
                <div>Instructions:</div>
                <div>{{drink.strInstructions}}</div>
            </div>
        </div>
    </div>
</div>